export const pad = num => ("0" + num).slice(-2);

export const getTimeFromDate = dateString => {
    if (dateString) {
        const date = new Date(dateString);
        let hours = date.getHours(), minutes = date.getMinutes(), seconds = date.getSeconds();
        return pad(hours) + ":" + pad(minutes) + ":" + pad(seconds);
    } else {
        return "";
    }
};
export const milisecondsToTime = (time) => {
    let hours = Math.floor(time / 3600000);
    time = time - (hours * 3600000);
    let minutes = Math.floor(time / 60000);
    time = time - minutes * 60000;
    let secondes = Math.floor(time / 1000);

    return String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0") + ":" + String(secondes).padStart(2, "0");
};

export const secondsToTime = (seconds) => {
    let hours = Math.floor(seconds / 3600);
    seconds = seconds - (hours * 3600);
    let minutes = Math.floor(seconds / 60);
    seconds = seconds - minutes * 60;
    return String(hours).padStart(2, "0") + ":" + String(minutes).padStart(2, "0");
};

export const formatDate = (date) => {
    if (date) {
        var d = new Date(date),
            month = '' + (d.getMonth() + 1),
            day = '' + d.getDate(),
            year = d.getFullYear();

        if (month.length < 2) 
            month = '0' + month;
        if (day.length < 2) 
            day = '0' + day;

        return [year, month, day].join('-');
    } else { 

        return null
    }
};